

import request from './request';





//发布商机-产品类别
export function business_publish_product_cate(params) {
    return request({
        url:'/pc/business_publish/product_cate',
        method: 'get',
        params
    })
}
//商机列表
export function business_publish_lists(params) {
    return request({
        url:'/pc/business_publish/lists',
        method: 'get',
        params
    })
}
//商机详情
export function business_publish_detail(params) {
    return request({
        url:'/pc/business_publish/detail',
        method: 'get',
        params
    })
}
//应答列表
export function business_reply_lists(params) {
    return request({
        url:'/pc/business_reply/lists',
        method: 'get',
        params
    })
}
//商机发布
export function business_publish_add(data) {
    return request({
        url:'/pc/business_publish/add',
        method: 'post',
        data
    })
}
//商机删除
export function business_publish_delete(data) {
    return request({
        url:'/pc/business_publish/delete',
        method: 'delete',
        data
    })
}
// 应答
export function business_reply_add(data) {
    return request({
        url: `/pc/business_reply/add`,
        method: 'post',
        data
    })
}


